import { render, staticRenderFns } from "./BodySalesAnalysis.vue?vue&type=template&id=b41b79b8&scoped=true"
import script from "./BodySalesAnalysis.vue?vue&type=script&lang=js"
export * from "./BodySalesAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodySalesAnalysis.vue?vue&type=style&index=0&id=b41b79b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41b79b8",
  null
  
)

export default component.exports